import { render, staticRenderFns } from "./AddDistributor.vue?vue&type=template&id=40c4c53f&"
import script from "./AddDistributor.vue?vue&type=script&lang=js&"
export * from "./AddDistributor.vue?vue&type=script&lang=js&"
import style0 from "./AddDistributor.vue?vue&type=style&index=0&id=40c4c53f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports